import Config from 'Config';
import { refreshToken } from '../auth/actions';
import { loadCenters, loadGrades, loadTerms } from '../dashboard/common/actions';
import { loadLanguages } from '../languages/actions';
import { getDefaultRequestHeaders } from '../common/middleware/api';
import { loadWarningMessages } from '../dashboard/warningMessage/actions';
import globalize, { i18n } from '../common/services/globalize';
import analyticsTracker from '../common/services/analyticsTracker';
import cookieConsentService from '../common/services/cookieConsentService';

export const FRANCHISOR_REQUEST = 'FRANCHISOR_REQUEST';
export const FRANCHISOR_SUCCESS = 'FRANCHISOR_SUCCESS';
export const FRANCHISOR_FAILURE = 'FRANCHISOR_FAILURE';

export const FRANCHISOR_DETAILS_REQUEST = 'FRANCHISOR_DETAILS_REQUEST';
export const FRANCHISOR_DETAILS_SUCCESS = 'FRANCHISOR_DETAILS_SUCCESS';
export const FRANCHISOR_DETAILS_FAILURE = 'FRANCHISOR_DETAILS_FAILURE';

export const LOOKUPS_REQUEST = 'LOOKUPS_REQUEST';
export const LOOKUPS_SUCCESS = 'LOOKUPS_SUCCESS';
export const LOOKUPS_FAILURE = 'LOOKUPS_FAILURE';

const FRANCHISORS_URL = `${Config.frontofficeApiUrl}/api/franchisors`;
const LOOKUPS_URL = `${Config.frontofficeApiUrl}/api/lookups`;

const requestFranchisor = () => ({
	type: FRANCHISOR_REQUEST
});

const receiveFranchisor = (json) => ({
	type: FRANCHISOR_SUCCESS,
	payload: { ...json }
});

const franchisorError = () => ({
	type: FRANCHISOR_FAILURE
});

export const initCurrentFranchisor = (shouldRefreshToken = true) => (dispatch, getState) => {
	dispatch(requestFranchisor());
	const config = {
		headers: {
			...getDefaultRequestHeaders(getState()),
			'X-Franchisor-Id': null
		}
	};
	return fetch(`${FRANCHISORS_URL}?frontOfficeUrl=${encodeURIComponent(window.location)}`, config)
		.then(response => response.json().then(franchisor => {
			if (!response.ok) {
				dispatch(franchisorError());
			} else {
				globalize.init(franchisor);

				cookieConsentService.validateCookieConsent(franchisor);

				// start NewRelic browser agent
				if (typeof window !== 'undefined' && window.newrelic && cookieConsentService.getCookiePreferences(franchisor).analytics) {
					window.newrelic.start();
				}

				analyticsTracker.initAnalyticsTracking(franchisor);

				if (franchisor.customResourcesFile) {
					const customNamespace = `franchisor.${franchisor.customResourcesFile}`;
					i18n.loadNamespaces(customNamespace);
					i18n.setDefaultNamespace(customNamespace);
				}

				document.title = i18n.t('FO_Document_Title', { systemName: franchisor.systemName });

				dispatch(receiveFranchisor(franchisor));
				if (shouldRefreshToken) {
					dispatch(refreshToken());
				}
				dispatch(loadLanguages()).then(() => {
					dispatch(initLocalizedData());
				});
			}
		}));
};

export const initLocalizedData = () => dispatch => {
	dispatch(loadCurrentFranchisorDetails());
	dispatch(loadLookups());
	dispatch(loadCenters());
	dispatch(loadGrades());
	dispatch(loadTerms());
};

const requestLookups = () => ({
	type: LOOKUPS_REQUEST
});

const receiveLookups = (json) => ({
	type: LOOKUPS_SUCCESS,
	payload: { ...json }
});

const lookupsError = () => ({
	type: LOOKUPS_FAILURE
});

export const loadLookups = () => (dispatch, getState) => {
	dispatch(requestLookups());
	const config = {
		headers: getDefaultRequestHeaders(getState())
	};
	return fetch(LOOKUPS_URL, config)
		.then(response => response.json().then(json => {
			if (!response.ok) {
				dispatch(lookupsError());
			} else {
				dispatch(receiveLookups(json));
			}
		}));
};

const requestFranchisorDetails = () => ({
	type: FRANCHISOR_DETAILS_REQUEST
});

const receiveFranchisorDetails = (json) => ({
	type: FRANCHISOR_DETAILS_SUCCESS,
	payload: { ...json }
});

const franchisorDetailsError = () => ({
	type: FRANCHISOR_DETAILS_FAILURE
});

export const loadCurrentFranchisorDetails = () => (dispatch, getState) => {
	dispatch(requestFranchisorDetails());
	const config = {
		headers: getDefaultRequestHeaders(getState())
	};
	return fetch(`${FRANCHISORS_URL}/current`, config)
		.then(response => response.json().then(json => {
			if (!response.ok) {
				dispatch(franchisorDetailsError());
			} else {
				dispatch(receiveFranchisorDetails(json));
				dispatch(loadWarningMessages())
				document.title = i18n.t('FO_Document_Title', { systemName: json.systemName });//replace with localized system name
			}
		}));
};